// import { cA } from '@fullcalendar/core/internal-common';
import React, { useRef, useEffect } from "react";
import Calendar from "../shared/Calendar";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";
import moment from "moment";
import { calendarEvents } from "../shared/data";
const Schedule = ({ show, handleClose, eventClick }) => {
  let timeNow = moment();

  let events = [
    {
      title: "Dr. Indu Sanghvi",
      start: timeNow.format(),
      end: timeNow.add(1, "hours").format(),
    },
    {
      title: "Dr. Prabhat Rau",
      start: timeNow.add(1, "days").format(),
      end: timeNow.add(1, "hours").format(),
    },
    {
      title: "Dr. Ganika Gopal",
      start: timeNow.add(1, "days").format(),
      end: timeNow.add(1, "hours").format(),
    },
    {
      title: "Dr. Mukta Datta",
      start: timeNow.add(1, "days").format(),
      end: timeNow.add(1, "hours").format(),
    },
    {
      title: "Dr. Kamala Shan",
      start: timeNow.add(1, "days").format(),
      end: timeNow.add(1, "hours").format(),
    },
  ];

  const calendarRef = useRef();

  const handleClick = () => {
    events = [
      {
        title: "Dr. Indu Sanghvi",
        start: timeNow.add(2, "hours").format(),
        end: timeNow.add(1, "hours").format(),
      },
      {
        title: "Dr. Prabhat Rau",
        start: timeNow.add(1, "days").format(),
        end: timeNow.add(1, "hours").format(),
      },
      {
        title: "Dr. Ganika Gopal",
        start: timeNow.add(1, "days").format(),
        end: timeNow.add(1, "hours").format(),
      },
      {
        title: "Dr. Mukta Datta",
        start: timeNow.add(1, "days").format(),
        end: timeNow.add(1, "hours").format(),
      },
      {
        title: "Dr. Kamala Shan",
        start: timeNow.add(1, "days").format(),
        end: timeNow.add(1, "hours").format(),
      },
    ];
    const myCalendar = calendarRef?.current?.getApi();
    myCalendar?.removeAllEvents();
    myCalendar?.addEventSource(events);
  };
  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Staff Schedule</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Calendar
            events={calendarEvents}
            calendarRef={calendarRef}
            eventClick={eventClick}
            title={"Dr. Ramaswamy"}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button onClick={handleClick}>Update Event</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Schedule;
